import { last } from "ramda";
import PropTypes from "prop-types";
import pluralize from "pluralize";

import { Title, Options } from "./styles";

const Details = ({ name, castOptions }) => {
  const formatCastOptions = (castNumOptions) => {
    const lastOption = last(castNumOptions);
    const firstOption = castNumOptions[0];
    if (lastOption !== firstOption) return `${firstOption} to ${lastOption} People`;
    return `${firstOption} ${pluralize("Person", firstOption)}`;
  };

  return (
    <>
      <Title variant="small">{name}</Title>
      <Options variant="small">Cast {formatCastOptions(castOptions)}</Options>
    </>
  );
};

Details.propTypes = {
  name: PropTypes.string,
  castOptions: PropTypes.arrayOf(PropTypes.number),
};

export default Details;
